import { confirmOTPEmail } from "../api/auth";
import { useAuthStore } from "../store/useAuthStore";
import { AuthModel } from "../types/auth";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useAuth = () => {
  const loginState = useAuthStore((state) => state.login);
  const logoutState = useAuthStore((state) => state.logout);

  const loginWithParams = (user: AuthModel) => {
    loginState(user, user.token);
  };

  const logout = () => {
    logoutState();
  };

  return {
    loginWithParams,
    logout,
  };
};

export const useConfirmEmail = () => {
  return useMutation({
    mutationFn: ({ email, otp }: { email: string; otp: string }) =>
      confirmOTPEmail(email, otp),
    onSuccess: (data) => {
      console.log("🎯 Active eSim successful:", data);
    },
    onError: (error) => {
      console.error("💥 Active eSim failed:", error);
    },
  });
};
